import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">
      <p class="mb-3 text-center bold">* * *</p>
      <p class="poem-block mb-3">
        Ankoraŭ foras vintr’…<br/>
        Sed nubo plumbe griza<br/>
        Alflugas al senstela firmament’,<br/>
        Kaj nin, anstataŭ tuŝ-tenero briza,<br/>
        Severe pelas akra norda vent’.
      </p>

      <p class="poem-block mb-3">
        Ankoraŭ foras vintr’,<br/>
        Sed jam animon premas<br/>
        Malhel-blueco de vespera hor’,<br/>
        Kaj pli mallaŭtas la birda ĥor’,<br/>
        Sed nokte pli aŭdeble arboj tremas,<br/>
        En vintra lingvo nudaj branĉoj ĝemas,<br/>
        Dum vento ilin kisas kun angor’.
      </p>

      <p class="poem-block mb-3">
        Ankoraŭ foras vintr’.<br/>
        Sed dum la suno brilas,<br/>
        Dum povas spiri ni kaj kanti en plenfort’,<br/>
        En nia kant’ la sun’ kaj viv’ jubilos<br/>
        Kaj spitos al la mort’!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Ankoraŭ foras vintr’…'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;